export const LOCAL_STORAGE_KEYS = {
    SIDEBAR_WIDTH: 'psv-sidebar-width',
};
export const REDIRECT_URL_STORAGE_KEY = {
    REDIRECT_URL: 'psv-redirect-url',
};
